const Loader = () => {
  return (
    <div style={styles.container}>
      <img src="/loader.gif" alt="Loading..." style={styles.gif} />
    </div>
  );
};

const styles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
    zIndex: 9999,
  },
  gif: {
    width: '120px',
    height: '120px',
  },
};

export default Loader;
